<div class="xi-modal__container upload-create__container" *transloco="let t; read: 'upload-create'">
  <h2 class="xi-modal__title">
    {{ isEditMode ? t('edit-collection-settings') : t('create-collection') }}
  </h2>

  <div class="xi-modal__content">
    @if (isLoading) {
      <div class="xi-loader-container__center">
        <xi-animation
          [width]="300"
          [height]="300"
          [loop]="true"
          animation="cx_loader"
        ></xi-animation>
      </div>
    } @else {
      <form [formGroup]="form" class="upload-create__form">
        <div>
          <xi-input-field
            [label]="t('name')"
            [placeholder]="t('name-for-collection')"
            name="collectionName"
            formControlName="name"
            [status]="collectionNameStatus"
            appAutoFocus="xiInput"
          ></xi-input-field>
        </div>
        <xi-text-area [label]="t('notes')" formControlName="notes" type="text"> </xi-text-area>
        <div class="upload-create__content-channel-container">
          <label class="kxi-label upload-create__label">{{ t('content-channel') }}</label>
          <div class="upload-create__content-channel">
            <ul class="upload-create__list upload-create__content-channel-list">
              @for (contentChannel of contentChannels; track contentChannel) {
                <li
                  class="upload-create__list-item"
                  [class.upload-create__list-item--selected]="contentChannel === contentChannel1"
                  (click)="onSelectContentChannel1(contentChannel)"
                >
                  {{ contentChannel | contentChannelLabel: activeLang }}
                </li>
              }
            </ul>
            <ul class="upload-create__list upload-create__content-channel-list">
              @for (contentChannel of contentChannel1.children; track contentChannel) {
                <li
                  class="upload-create__list-item"
                  [class.upload-create__list-item--selected]="contentChannel === contentChannel2"
                  (click)="onSelectContentChannel2(contentChannel)"
                >
                  {{ contentChannel | contentChannelLabel: activeLang }}
                </li>
              }
            </ul>
            <ul class="upload-create__list upload-create__content-channel-list">
              @for (contentChannel of contentChannel2.children; track contentChannel) {
                <li
                  class="upload-create__list-item"
                  [class.upload-create__list-item--selected]="contentChannel === contentChannel3"
                  (click)="onSelectContentChannel3(contentChannel)"
                >
                  {{ contentChannel | contentChannelLabel: activeLang }}
                </li>
              }
            </ul>
          </div>
        </div>
        @if (!isEditMode) {
          <div class="upload-create__radios">
            <xi-radio
              value="empty"
              [label]="t('empty-collection')"
              color="CX"
              name="followUp"
              formControlName="followUp"
            ></xi-radio>
            <xi-radio
              value="upload"
              [label]="t('upload-file')"
              color="CX"
              name="followUp"
              formControlName="followUp"
            ></xi-radio>
          </div>
        }
        @if (shouldShowSectionSeparator) {
          <div class="upload-create__section-separator-container">
            <div class="upload-create__section-separator-label-container">
              <label
                class="kxi-label upload-create__label upload-create__section-separator-label"
                >{{ t('section-separator-label') }}</label
              >
              <xi-icon
                icon="info"
                color="CX"
                [tooltipProps]="{ text: t('section-separator-info'), direction: 3 }"
              ></xi-icon>
            </div>
            <xi-dropdown
              select="single"
              [stretch]="true"
              [data]="sectionFieldOptions"
              [value]="sectionSeparator"
              (onValueChange)="onSelectSectionSeparator($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
        }
        @if (shouldShowFocusedSpeakerSeparator) {
          <div class="upload-create__section-separator-container">
            <div class="upload-create__section-separator-label-container">
              <label
                class="kxi-label upload-create__label upload-create__section-separator-label"
                >{{ t('section-focus-speaker-label') }}</label
              >
              <xi-icon
                icon="info"
                color="CX"
                [tooltipProps]="{ text: t('section-focus-speaker-info'), direction: 3 }"
              ></xi-icon>
            </div>
            <xi-dropdown
              select="single"
              [stretch]="true"
              [data]="focusedSpeakerFieldOptions"
              [value]="focusSeparator"
              (onValueChange)="onSelectFocusedSpeakerSeparator($event.detail.selected.id)"
            ></xi-dropdown>
          </div>
        }
      </form>
    }
  </div>

  <div class="xi-modal__actions upload-create__action">
    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="isEditMode ? t('update-settings') : t('create-collection')"
        buttonSize="large"
        [disabled]="isConfirmDisabled"
        (onClick)="onConfirm()"
      ></xi-default-button>

      @if (isSaving) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="100"
            [width]="100"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</div>
